





























































































































































































































































































































































































































import Page from '@/Page.vue';
import {Component, Prop, Ref, Watch} from 'vue-property-decorator';
import WorkTaskKanbanColumn from '@/libs/work-tasks/components/WorkTaskKanbanColumn.vue';
import WorkTaskDialog from '@/libs/work-tasks/components/WorkTaskDialog.vue';
import PartyWorkDayDialog from '@/libs/work-tasks/components/PartyWorkDayDialog.vue';
import {WorkTaskKanbanColumnModel} from '@/libs/work-tasks/model/WorkTaskKanbanColumnModel';
import moment from 'moment';
import {
	AccountTypeEnum,
	PartyWorkDayModel,
	SortOrder, TenantModel,
	TenantUserModel,
	WorkTaskModel,
	WorkTaskStatementModel
} from '@/libs/Api';
import {partyWorkDaysStore} from '@/libs/party-work-days/+state/store';
import {CrudAction, CrudReponse} from '@/libs/core/+state/models/crud-action';
import {CrudGetter} from '@/libs/core/+state/models/crud-getter';
import {workTasksStore} from '../+state/store';
import {createCrudQueryPayload} from '@/libs/core/+state/models/crud-query-payload';
import {authStore} from '@/libs/auth/+store/store';
import {AuthGetter} from '@/libs/auth/models/auth-state';

import {directive, Swiper, SwiperSlide} from 'vue-awesome-swiper';
import {CrudDataStats} from '@/libs/core/+state/models/crud-data-stats';
import {Guid} from '@/libs/common/functions/guid';
import {CrudOrderBy} from '@/libs/core/+state/models/crud-order-by';
import ExportDialog from "@/libs/common/components-smart/ExportDialog.vue";
import {CrudQueryPredicate} from "@/libs/core/+state/models/crud-query-predicate";
import ApiService from "@/libs/core/api-service";
import {b64toBlob} from "@/libs/common/functions/b64toBlob";
import {tenantsStore} from "@/libs/tenants/+state/store";
import { Filters, PageFilter } from '@/filters';

@Component({
    components: {
        WorkTaskKanbanColumn,
        WorkTaskDialog,
        PartyWorkDayDialog,
        Swiper,
        SwiperSlide
    },
    directives: {
      swiper: directive
    }
})
export default class WorkTasks extends Page {

    kanbanItems: WorkTaskKanbanColumnModel[] = [];
    // tableItems: any[] = [];
    tableHeaders = [
        { text: "Datum", value: "day", align: "left", width: "5%" },
        { text: "Klient", value: "party.lastName", align: "left", width: "10%" },
        { text: "Středisko", value: "party.district.name", align: "left", width: "10%" },
        { text: "Obec", value: "party.town.name", align: "left", width: "10%" },
        { text: "Adresa", value: "party.city", align: "left", width: "10%" },
        { text: "Pečovatel", value: "party.mainCareProvider.displayName", align: "left", sortable: false, width: "10%" },
        { text: "Telefonní číslo", value: "party.phoneNumber", align: "left", width: "10%" },
        { text: "Úkony k provedení", value: "remainingWorkTasks", align: "left", width: "10%" },
        { text: "Dokončeno", value: "doneWorkTasks", align: "left", width: "10%" },
        { text: "Ručně naplánované", value: "isUserDefined", align: "left", width: "10%" },
        { text: "", value: "id", align: "left", sortable: false, width: "5%" },
    ];
    currentDate: any = null;
    partyFilter: string | null = null;
    districtFilter: string | null = null;
    townFilter: string | null = null;
    userFilter: string | null = null;
    dateFilter: any = null; 
    tab = "table";
    since = new Date();
    until = new Date();
    swiperOptions = {};
    mobileFiltersShow = false;
    pagingChanged = false;
    pageIndex = 1;
    pageSize = 25;
    pageInitialization = true;
    sortBy = [ "day" ];
    sortDesc = [ false ];
	isUserDefined = false;
    printing = false;
    // selected = [];

    get calendarTitle(): string {
        return moment(this.currentDate).format("W. [týden]");
    }

    get isAdmin (): boolean {
        const tenantUser = authStore.useGetter(AuthGetter.GetTenantUser) as TenantUserModel;
        return tenantUser.accountType == AccountTypeEnum.Admin;
    }

    get isUserFilterReadonly(): boolean {
        const tenantUser = authStore.useGetter(AuthGetter.GetTenantUser) as TenantUserModel;
        return tenantUser.accountType == AccountTypeEnum.Worker;
    }

    items: WorkTaskModel[] = [];

    @Watch("partyFilter")
    @Watch("districtFilter")
    @Watch("townFilter")
    @Watch("userFilter")
    @Watch("isUserDefined")
    filtersChanged () {
		if (this.pageInitialization)
            return;
        if (this.tab == "table") {
            this.pageIndex = 1;
            this.loadItems();
        }
        this.saveQuery();
    }

    @Watch("pageIndex")
    @Watch("pageSize")
    paginationChanged () {
        if (this.pageInitialization)
            return;
        this.saveQuery();
        if (this.pagingChanged) {
            this.pagingChanged = false;
            return;
        }
        this.loadItems();
    }

    @Watch("sortBy")
    @Watch("sortDesc")
    sortChanged () {
        this.saveQuery();
        if (this.pagingChanged) {
            this.pagingChanged = false;
            return;
        }
        this.loadItems();
    }

    @Watch("pageSize")
    pageSizeChanged () {
        this.pageIndex = 1;
    }

    get loading(): boolean {
        return partyWorkDaysStore.useGetter(CrudGetter.PendingBasic, "WorkTaskItemsTable");
    }

    get tableItems(): WorkTaskModel[] {
        return partyWorkDaysStore.useGetter(CrudGetter.DataBasic, "WorkTaskItemsTable");
    }

    get totalRows(): number {
        var stats = partyWorkDaysStore.useGetter(CrudGetter.DataStatsBasic, "WorkTaskItemsTable") as CrudDataStats;
        return stats?.rowCount ?? 0;
    }

	get exporting(): boolean {
		return workTasksStore.useGetter(CrudGetter.Downloading);
	}

    @Prop() tenantId!: string;
    @Ref() dialog!: WorkTaskDialog;
    @Ref() partyWorkDayDialog!: PartyWorkDayDialog;
    @Ref() kanbanColumns!: WorkTaskKanbanColumn[];
	@Ref() exportDialog!: ExportDialog;

    @Watch("tab")
    tabChanged (v: string, p: string) {
        if (this.pageInitialization)
            return;
        if (v != p && v == "kanban") {
            this.makeDays();
        }
        else if (v != p && v == "table") {
            this.loadItems();
        }
        if (v != p) {
            this.saveQuery();
        }
    }

    @Watch("dateFilter")
    dateFilterChanged (v: string, p: string) {
        if (this.pageInitialization)
            return;
        if (!moment(v).isSame(moment(p))) {
            this.pageIndex = 1;
            this.currentDate = v;
        }
    }

    @Watch("currentDate")
    currentDateChanged (v: Date) {
        if (this.pageInitialization)
            return;
        if (this.tab == "kanban") {
            this.makeDays();
        }
        else {
            this.loadItems();
        }
        this.setQuery("date", moment(v).format("YYYY-MM-DD"));
    }

    saveQuery () {
        this.setQuery("party", this.partyFilter);
        this.setQuery("district", this.districtFilter);
        this.setQuery("town", this.townFilter);
        this.setQuery("user", this.userFilter);
        this.setQuery("view", this.tab);
        this.setQuery("pageSize", this.pageSize?.toString());
        this.setQuery("date", moment(this.currentDate).format("YYYY-MM-DD"));
        const filters: PageFilter = {
            pageName: 'WorkTasks',
            filters: [
                { name: 'party', value: this.partyFilter },
                { name: 'district', value: this.districtFilter },
                { name: 'town', value: this.townFilter },
                { name: 'user', value: this.userFilter },
                { name: 'tab', value: this.tab },
                { name: 'pageSize', value: this.pageSize > 0 ? this.pageSize : 25 }
            ]
        };
        Filters.saveFilters(filters);
    }

    clearFilters () {
        this.partyFilter = null;
        if (this.isAdmin) {
            this.districtFilter = null;
        }
        this.townFilter = null;
        this.userFilter = null;
        this.saveQuery();
    }

    created () {
        if (this.getQuery("view") != null || this.getQuery("party") != null || this.getQuery("district") != null || this.getQuery("town") != null || this.getQuery("user") != null || this.getQuery("pageSize") != null || this.getQuery("date") != null) {
            this.tab = this.getQuery("view") ?? "kanban";
            this.partyFilter = this.getQuery("party");
            this.districtFilter = this.getQuery("district");
            this.townFilter = this.getQuery("town");
            this.userFilter = this.getQuery("user");
            this.pageSize = this.getQueryInt("pageSize") ?? 25;
            this.currentDate = moment(this.getQuery("date")).isValid() ? moment(this.getQuery("date")).format("YYYY-MM-DDT00:00:00") : moment().startOf("isoWeek").format("YYYY-MM-DDT00:00:00");
            this.dateFilter = moment(this.getQuery("date")).isValid() ? moment(this.getQuery("date")).format("YYYY-MM-DDT00:00:00") : moment().startOf("isoWeek").format("YYYY-MM-DDT00:00:00");
        }
        else {
            this.tab = Filters.loadFilter('WorkTasks', 'tab') ?? 'kanban';
            this.partyFilter = Filters.loadFilter('WorkTasks', 'party') ?? null;
            this.districtFilter = Filters.loadFilter('WorkTasks', 'district') ?? null;
            this.townFilter = Filters.loadFilter('WorkTasks', 'town') ?? null;
            this.userFilter = Filters.loadFilter('WorkTasks', 'user') ?? null;
            this.pageSize = Number(Filters.loadFilter('WorkTasks', 'pageSize', '25')) ?? 25;
            this.currentDate = moment().startOf("isoWeek").format("YYYY-MM-DDT00:00:00");
            this.dateFilter = moment().startOf("isoWeek").format("YYYY-MM-DDT00:00:00");
            this.saveQuery();
        }
		const tenantUser = authStore.useGetter(AuthGetter.GetTenantUser) as TenantUserModel;
		if (tenantUser.accountType == AccountTypeEnum.Worker) {
			this.userFilter = tenantUser.userId!;
		}
    }

    mounted () {
        this.$nextTick(() => {
            this.pageInitialization = false;
            if (this.tab == "kanban") {
                this.makeDays();
            }
            else if (this.tab == "table") {
                this.loadItems();
            }
        });
    }

    next () {
        this.currentDate = moment(this.currentDate).add(1, "week").format("YYYY-MM-DDT00:00:00");
        this.dateFilter = this.currentDate;
    }

    prev () {
        this.currentDate = moment(this.currentDate).add(-1, "week").format("YYYY-MM-DDT00:00:00");
        this.dateFilter = this.currentDate;
    }

    makeDays () {
        this.kanbanItems = [];
        let since = moment(this.currentDate).toDate();
        const until = moment(since).add(7, "day").toDate();
        this.since = since;
        this.until = until;
        while (since < until) {
            this.kanbanItems.push({
                id: moment(since).format("YYYY-MM-DD"),
                date: since
            } as WorkTaskKanbanColumnModel);
            since = moment(since).add(1, "day").toDate();
        }
    }

    open (item: PartyWorkDayModel) {
        this.dialog.open(item.id!, item!.partyId!, item.day!);
    }

    getPredicates (): CrudQueryPredicate[] {
        const filterPredicates = [
            { field: "day", op: "gte", comparand: moment(this.currentDate).startOf("week").format("YYYY-MM-DDT00:00:00") },
            { field: "day", op: "lte", comparand: moment(this.currentDate).endOf("week").format("YYYY-MM-DDT00:00:00") }
        ] as any;
        if (this.partyFilter)
            filterPredicates.push({ field: "partyId", op: "eq", comparand: this.partyFilter! });
        if (this.districtFilter)
            filterPredicates.push({ field: "party.districtId", op: "eq", comparand: this.districtFilter! });
        if (this.townFilter)
            filterPredicates.push({ field: "party.townId", op: "eq", comparand: this.townFilter! });
        if (this.userFilter)
            filterPredicates.push({ field: "partyWorkDayUsers.userId", op: "eq", comparand: this.userFilter! });
        if (this.isUserDefined)
            filterPredicates.push({ field: "id", op: "wrap", comparand: [
				{ field: "isUserDefined", op: "eq", comparand: true, junction: "or" },
				{ field: "workTasks.isUserDefined", op: "eq", comparand: true, junction: "or" }
			] });
        return filterPredicates;
    }

    loadItems () {
        if (this.tab == "table") {
            const orderBy: CrudOrderBy<PartyWorkDayModel>[] = [];
            if (this.sortBy.length == 0) {
                orderBy.push({
                    field: "day",
                    index: 1,
                    order: "asc"
                });
            }
            else {
                orderBy.push({
                    field: this.sortBy.first(),
                    index: 1,
                    order: this.sortDesc.first() ? "desc" : "asc"
                });
            }
            partyWorkDaysStore.dispatch(CrudAction.GetAllBasic, createCrudQueryPayload<PartyWorkDayModel>(orderBy, this.getPredicates(), {
                pageIndex: this.pageIndex,
                pageSize: this.pageSize
            }, false, "WorkTaskItemsTable"));
        }
        else {
            this.kanbanColumns.forEach(x => {
                x.refresh();
            });
        }
    }

    getInitials (v: string) {
        let rgx = new RegExp(/(\p{L}{1})\p{L}+/, 'gu');

        let initials: any = [...v.matchAll(rgx)] || [];

        initials = (
            (initials.shift()?.[1] || '') + (initials.pop()?.[1] || '')
        ).toUpperCase();

        return initials;
    }

    createClick () {
        this.partyWorkDayDialog.open();
    }

    create (partyId: string, day: string) {
        this.partyWorkDayDialog.close();
        this.dialog.open(Guid.EmptyGuid(), partyId, day);
    }

    createdItem (e: PartyWorkDayModel) {
        const kanbanColumn = this.kanbanColumns?.firstOrDefault(x => moment(x.date).format("YYYY-MM-DD") === moment(e.day).format("YYYY-MM-DD"));
        if (kanbanColumn)
            kanbanColumn.refresh();
    }

	deletedItem (e: PartyWorkDayModel) {
		const kanbanColumn = this.kanbanColumns?.firstOrDefault(x => moment(x.date).format("YYYY-MM-DD") === moment(e.day).format("YYYY-MM-DD"));
		if (kanbanColumn) {
			kanbanColumn.refresh(true);
		}
	}

    canRecord(item: PartyWorkDayModel) {
        if (moment(item.day).isSameOrAfter(moment().add(1, "day").startOf("day"))) {
            return false;
        }
        return true;
    }

	exportClick () {
		this.exportDialog.open();
	}
    
    printClick () {
		this.printing = true;
        ApiService.api.printPartyWorkDayBatch({
            date: moment().format("YYYY-MM-DDTHH:mm:ss"),
            fileName: "Plán práce",
            predicates: this.getPredicates() as any[],
            orderby: [
                { field: "day", index: 1, order: SortOrder.Asc }
            ]
        }).then((e: any) => {
            this.printing = false;
            const res = e.data;
            const blob = b64toBlob(res.returnValue.base64, res.returnValue.contentType);
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.setAttribute('download', res.returnValue.filename!);
            document.body.appendChild(link);
            link.click();
            link.parentNode!.removeChild(link);
        }).catch((e) => {
            console.log(e);
            this.printing = false;
        });
	}
    
    getWorkTaskPredicates(): CrudQueryPredicate[] {
        const filterPredicates = [
            { field: "partyWorkDay.day", op: "gte", comparand: moment(this.currentDate).startOf("week").format("YYYY-MM-DDT00:00:00") },
            { field: "partyWorkDay.day", op: "lte", comparand: moment(this.currentDate).endOf("week").format("YYYY-MM-DDT00:00:00") }
        ] as any;
            if (this.partyFilter)
            filterPredicates.push({ field: "partyWorkDay.partyId", op: "eq", comparand: this.partyFilter! });
        if (this.districtFilter)
            filterPredicates.push({ field: "partyWorkDay.party.districtId", op: "eq", comparand: this.districtFilter! });
        if (this.townFilter)
            filterPredicates.push({ field: "partyWorkDay.party.townId", op: "eq", comparand: this.townFilter! });
        if (this.userFilter)
            filterPredicates.push({ field: "partyWorkDay.partyWorkDayUsers.userId", op: "eq", comparand: this.userFilter! });
        if (this.isUserDefined)
            filterPredicates.push({ field: "id", op: "wrap", comparand: [
                    { field: "partyWorkDay.isUserDefined", op: "eq", comparand: true, junction: "or" },
                    { field: "partyWorkDay.workTasks.isUserDefined", op: "eq", comparand: true, junction: "or" }
                ] });
        return filterPredicates;
    }

	exportDownload () {
        const payload = createCrudQueryPayload<WorkTaskStatementModel>({ field: "time", index: 1, order: "asc"}, this.getWorkTaskPredicates());
		workTasksStore.dispatch(CrudAction.Download, payload);
		this.subscribe(workTasksStore, CrudReponse.Download).then(() => {
			this.exportDialog.close();
		});
	}

}
